import { useEffect,useState } from 'react'
import { Alert, Card, CardContent, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material'
import { useParams,useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { DatePicker } from 'zaman'
import { get, post } from '../../../utils/axios'
import Button from '../../../components/Button'

const AddChildrenSegments = () => {

    const navitate = useNavigate()
    const {childId} = useParams()

    const [isLoading,setIsLoading] = useState(false)
    const [formData,setFormData] = useState({segmentId: '',limit: '',percent: '',fromDate: new Date(),toDate: new Date()})
    const [segments,setSegments] = useState([])
    const [type,setType] = useState('percent')
    const [isChanged,setIsChanged] = useState(false)

    useEffect(() => {
        get('Segment/GetSegment').then(({data}) => {
            if(data.isSuccess)
                setSegments(data.data)
        })
    },[])

    useEffect(() => {
        if(formData.percent && formData.percent.length){
            if(formData.percent.includes('۰'))
                setFormData({...formData,percent: formData.percent.replace(/۰/g,'0')})
            if(formData.percent.includes('۱'))
                setFormData({...formData,percent: formData.percent.replace(/۱/g,'1')})
            if(formData.percent.includes('۲'))
                setFormData({...formData,percent: formData.percent.replace(/۲/g,'2')})
            if(formData.percent.includes('۳'))
                setFormData({...formData,percent: formData.percent.replace(/۳/g,'3')})
            if(formData.percent.includes('۴'))
                setFormData({...formData,percent: formData.percent.replace(/۴/g,'4')})
            if(formData.percent.includes('۵'))
                setFormData({...formData,percent: formData.percent.replace(/۵/g,'5')})
            if(formData.percent.includes('۶'))
                setFormData({...formData,percent: formData.percent.replace(/۶/g,'6')})
            if(formData.percent.includes('۷'))
                setFormData({...formData,percent: formData.percent.replace(/۷/g,'7')})
            if(formData.percent.includes('۸'))
                setFormData({...formData,percent: formData.percent.replace(/۸/g,'8')})
            if(formData.percent.includes('۹'))
                setFormData({...formData,percent: formData.percent.replace(/۹/g,'9')})
        }
    },[formData.percent])

    const addChildSegment = () => {
        setIsLoading(true)
        const postedData = {
            userId: childId,
            segmentId: formData.segmentId,
            limit: type == 'amount' && formData.limit ? formData.limit.toString().replace(/,/g,'') : 0,
            limitPercent: type == 'percent' && formData.percent ? parseInt(formData.percent) : 0,
            fromDate: formData.fromDate.toLocaleDateString('fr-CA').replace(/-/g,'/'),
            toDate: formData.toDate.toLocaleDateString('fr-CA').replace(/-/g,'/')
        }
        post('ChildUser/AddTrasactionInfoChildUser',postedData).then(({data}) => {
            if(data.isSuccess){
                toast.success('منبع مالی جدید افزوده شد')
                navitate(-1)
            }else
                toast.error(data.message)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        if(formData.fromDate && isChanged){
            const fromDate = new Date(formData.fromDate)
            if(fromDate < new Date().setHours(0,1,0,0))
                toast.warning('تاریخ شروع نمی تواند قبل از تاریخ امروز باشد')
        }
    },[formData.fromDate])

    useEffect(() => {
        if(formData.toDate && isChanged){
            const fromDate = new Date(formData.fromDate)
            const toDate = new Date(formData.toDate)
            if(toDate < fromDate)
                toast.warning('تاریخ پایان نمی تواند قبل از تاریخ شروع باشد')
        }
    },[formData.toDate])

    const setAmountValue = value => {
        value = value.toString().replace(/,/g,'')
        value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value)
        if(value == 'NaN')
            value = '';
        setFormData({...formData,limit: value})
    }

    const setFromDate = date => {
        if(!isChanged)
            setIsChanged(true)
        setFormData({...formData,fromDate: date})
        document.getElementsByClassName('rdp__overlay')[0].click()
    }

    const setToDate = date => {
        if(!isChanged)
            setIsChanged(true)
        setFormData({...formData,toDate: date})
        document.getElementsByClassName('rdp__overlay')[0].click()
    }

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">تخصیص منبع مالی جدید</h3>
            <div className="safe-area">
                <Card sx={{width: '100%',mb: 2}}>
                    <CardContent sx={{py: 3,pb: 4}}>
                        <FormControl fullWidth>
                            <InputLabel id="app-theme-label">بخش</InputLabel>
                            <Select labelId="app-theme-label" label="بخش" onChange={e => setFormData({...formData,segmentId: e.target.value})}>
                                {segments.map(segment => <MenuItem key={segment.id} value={segment.id}>{segment.title}</MenuItem>)}
                            </Select>
                        </FormControl>
                        <RadioGroup defaultValue="percent" name="type" value={type} onChange={e => setType(e.target.value)} sx={{ mt: 2,mb: 1.2 }} row>
                            <FormControlLabel value="percent" control={<Radio />} label="بر اساس درصد" />
                            <FormControlLabel value="amount" control={<Radio />} label="بر اساس مبلغ" />
                        </RadioGroup>
                        {type == 'percent' ? <TextField label="درصد قابل استفاده" type="tel" inputProps={{maxLength: 3}} className="ltr-input" variant="standard" fullWidth sx={{mb: 2.5}} onChange={e => setFormData({...formData,percent: e.target.value})} value={formData.percent} onBlur={e => e.target.value > 100 ? setFormData({...formData,percent: '100'}) : false} /> : <TextField label="حداکثر مبلغ قابل استفاده (ریال)" type="tel" inputProps={{maxLength: 12}} className="ltr-input" variant="standard" fullWidth sx={{mb: 2.5}} onChange={e => setAmountValue(e.target.value)} value={formData.limit} />}
                        <Alert variant="standard" color="info" sx={{mb: 3}}>فرصت استفاده از اعتبار تخصیص داده شده، تا ساعت 23:59 تاریخ انتخابی جهت پایان اعتبار می باشد</Alert>
                        <div className="form__group">
                            <DatePicker inputClass="form__field" onChange={e => setFromDate(e.value)} defaultValue={formData.fromDate} />
                            <label className="form__label">تاریخ شروع</label>
                        </div>
                        <div className="form__group">
                            <DatePicker inputClass="form__field" onChange={e => setToDate(e.value)} defaultValue={formData.toDate} />
                            <label className="form__label">تاریخ پایان</label>
                        </div>
                        <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{mt: 3,py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!formData.segmentId || formData.percent > 100} onClick={addChildSegment}>تخصیص</Button>
                    </CardContent>
                </Card>
            </div>
        </Grid>
    )
}

export default AddChildrenSegments